import script from "./child-launch-edit-form.vue?vue&type=script&setup=true&lang=js"
export * from "./child-launch-edit-form.vue?vue&type=script&setup=true&lang=js"

import "./child-launch-edit-form.vue?vue&type=style&index=0&id=08f8d010&lang=css"

const __exports__ = script;

export default __exports__